import { useSelector } from 'react-redux';
import { PurchaseState } from '../../models/purchase/purchase.model';
import { RootState } from '../../models/_root-state.model';

export const usePurchase = (): PurchaseState => useSelector((state: RootState) => state.purchaseBranch);
